<template>
  <div class="login" :style="cssProps">
    <div class="upperBand">
      <img class="appLogo" :src="organizationLogo" />
    </div>
    <div class="midBox">
      <div class="organizationInfo">
        <img :src="this.$config.theme.default.loginPage.organizationLogo" />
        <div v-show="showError" class="errorMessage">
          {{ message }}
        </div>
      </div>

      <div class="flip-card" ref="loginInfoBox">
        <div class="flip-card-inner">
          <div class="flip-card-front" @click="cardClicked">
            <div class="wrapper">
              <div class="infoTitle">{{ appDisplayName }}'e hoşgeldiniz.</div>
              <div class="infoRow">
                <div>
                  <qrcode :value="qrCode" :options="{ width: 200 }" v-if="qrCode !== ''" />
                  <div class="qrTimer" v-if="qrTimer > 0">
                    {{ qrTimer }}
                  </div>
                </div>
                <div class="infoContainer">
                  <div class="infoTitleDesc">{{ appDisplayName }}'i kullanabilmek için</div>
                  <div class="infoTitleDesc"><b>a-</b> {{ appDisplayName }} uygulamasını telefonunuzda açın.</div>
                  <div class="infoTitleDesc"><b>b-</b> Soldaki karekodu telefonunuzdaki {{ appDisplayName }} uygulamasında okutun.</div>
                  <div class="infoTitleDesc">
                    <b>veya</b>
                  </div>
                  <div class="infoTitleDesc"><b>c-</b> Buraya tıklayarak kullanıcı adı ve parolanızla giriş yapın.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flip-card-back credentialLogin">
            <!-- <div class="svgContainer">
              <svg class="svgBackButton" @click="cardClicked"><rect width="100" height="100" /></svg>
              <div class="logo" />
            </div> -->

            <div class="loginTitle">
              Giriş
            </div>
            <div class="inputTitle">
              Kullanıcı Adı
            </div>
            <input type="text" name="userName" ref="userNameInput" v-model="userName" @keyup.enter="focusPassword" />
            <div class="inputTitle">
              Parola
            </div>
            <input type="password" name="password" ref="passwordInput" v-model="password" @keyup.enter="submitForm" />
            <div class="loginRow">
              <div class="loginBtn" @click="submitForm"><img src="@/assets/images/loginbtnicon.png" /> Giriş</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { qrSocketInputMixin } from '@/mixins/qrSocketInputMixin.js'
import EventBus from '@/eventbus.js'
import { AuthorizationServiceConfiguration, AuthorizationNotifier, FetchRequestor, RedirectRequestHandler, LocalStorageBackend, DefaultCrypto, BasicQueryStringUtils, AuthorizationRequest, TokenRequest, BaseTokenRequestHandler } from '@openid/appauth'

class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input, useHash) {
    return super.parse(input, false /* never use hash */)
  }
}

const authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(), new NoHashQueryStringUtils(), window.location, new DefaultCrypto())

const notifier = new AuthorizationNotifier()
authorizationHandler.setAuthorizationNotifier(notifier)
const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor())

notifier.setAuthorizationListener((request, response, error) => {
  if (response) {
    let extras = null
    if (request && request.internal) {
      extras = {
        client_secret: process.env.VUE_APP_CLIENTSECRET,
        code_verifier: request.internal.code_verifier
      }
    }

    // A. First, you need to create a token request object
    const tokenRequest = new TokenRequest({
      client_id: process.env.VUE_APP_CLIENTID,
      redirect_uri: process.env.VUE_APP_REDIRECTURL,
      grant_type: 'authorization_code',
      code: response.code,
      extras
    })
    // B. Again get configuration information
    AuthorizationServiceConfiguration.fetchFromIssuer(process.env.VUE_APP_OP_SERVER, new FetchRequestor())
      .then(oResponse => {
        const configuration = oResponse
        // C. Hit `/token` endpoint and get token
        return tokenHandler.performTokenRequest(configuration, tokenRequest)
      })
      .then(oResponse => {
        let tkn = localStorage.getItem('spatkn')
        let config = {
          headers: {
            Authorization: 'Bearer ' + tkn
          }
        }

        axios
          .post(
            process.env.VUE_APP_SSOLOGINURL,
            {
              Token: oResponse.accessToken,
              isMobile: 0
            },
            config
          )
          .then(res => {
            vm.$store.state.session.user.Token = res.data.Token
            vm.$store.state.session.user.UserID = res.data.UserID
            vm.slo('ssn', vm.$store.state.session)

            vm.$router.push({
              name: 'Home'
            })
          })
          .catch(err => {
            console.log(err)
          })

        /* MUHTEMELEN AŞAĞIDAKİ KOD YNALIŞ

        console.log(oResponse)
        var key = oResponse.username
        var iv = oResponse.username
          .split('')
          .reverse()
          .join('')
        let encPass = this.ewk(oResponse.password, key, iv)
        this.axios
          .post(
            process.env.VUE_APP_LOGINURL,
            {
              UserID: vm.userName,
              Password: encPass,
              isMobile: false
            },
            config
          )
          .then(response => {
            debugger
            if (response.data.Success == true) {
              debugger
              this.$store.state.session.user.Token = response.data.Token
              this.$store.state.session.user.UserID = vm.userName
              this.slo('ssn', vm.$store.state.session)
              this.$router.push({
                name: 'Home'
              })
            } else {
              debugger
              this.hasError = true
              this.errorMessage = response.data.Error
            }
          })
          .catch(function(error) {
            console.log(error)
            vm.hasError = true
            vm.errorMessage = 'Bir hata oluştu, lütfen daha sonra tekrar deneyiniz.'
          })

          */
        localStorage.setItem('access_token', oResponse.accessToken)
        // do operation now as per your need
        // props.history.push('/profile')
      })
      .catch(oError => {
        console.log(oError)
      })
  }
})
authorizationHandler.completeAuthorizationRequestIfPossible()

require('@/security.js')

var Color = require('color')
var vm

export default {
  name: 'Login',
  props: {
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },

  mixins: [qrSocketInputMixin],

  data() {
    return {
      qrCode: '',
      qrTimer: 0,
      qrTimerTimeoutId: null,
      userName: '',
      password: '',
      value: 'Burak Atlı',
      isLoginBoxFlipped: false,
      appDisplayName: process.env.VUE_APP_APPDISPLAYNAME,
      showError: this.hasError,
      message: this.errorMessage
    }
  },

  computed: {
    cssProps() {
      return {
        '--topBarColor': this.$config.theme.default.loginPage.topBarColor,
        '--loginBtnColor': this.$config.theme.default.loginPage.loginBtnColor,
        '--loginBtnHoverColor': Color(this.$config.theme.default.loginPage.loginBtnColor).darken(0.2),
        '--colorTextColor': this.$config.theme.default.loginPage.colorTextColor
      }
    },
    organizationLogo() {
      return this.$config.theme.default.loginPage.organizationLogo
    }
  },

  methods: {
    setQrCode(qrCode) {
      if (this.qrTimerTimeoutId !== null) {
        clearTimeout(this.qrTimerTimeoutId)
        this.qrTimerTimeoutId = null
      }
      this.qrCode = this.$store.state.socket.browserUuid + '|' + qrCode
      this.qrTimer = 300
      this.tickTimer()
    },

    cardClicked() {
      if (this.$refs.loginInfoBox !== undefined) {
        this.$refs.loginInfoBox.classList.toggle('flipped')
        this.$refs.userNameInput.focus()
        this.isLoginBoxFlipped = !this.isLoginBoxFlipped
      }
    },

    focusPassword() {
      this.$refs.passwordInput.focus()
    },
    submitSSO() {
      AuthorizationServiceConfiguration.fetchFromIssuer(process.env.VUE_APP_OP_SERVER, new FetchRequestor())
        .then(response => {
          const authRequest = new AuthorizationRequest({
            client_id: process.env.VUE_APP_CLIENTID,
            redirect_uri: process.env.VUE_APP_REDIRECTURL,
            scope: 'openid name tckimlik',
            response_type: AuthorizationRequest.RESPONSE_TYPE_CODE
            // extras: environment.extra
          })
          authorizationHandler.performAuthorizationRequest(response, authRequest)
        })
        .catch(error => {
          console.log(error)
        })
    },
    submitForm() { 
      if (!this.validateForm) {
        return
      }
      let config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.token
        }
      }

      var key = this.userName
      var iv = this.userName
        .split('')
        .reverse()
        .join('')
      let encPass = this.ewk(this.password, key, iv) 

      this.axios
        .post(
          process.env.VUE_APP_LOGINURL,
          {
            UserID: vm.userName,
            Password: encPass,
            isMobile: false
          },
          config
        )
        .then(response => {
          if (response.data.Success == true) {
            vm.$store.state.session.user.Token = response.data.Token
            vm.$store.state.session.user.UserID = vm.userName
            this.slo('ssn', vm.$store.state.session)
            vm.$router.push({
              name: 'Home'
            })
          } else {
            vm.showError = true
            vm.errorMessage = response.data.Error
          }
        })
        .catch(function(error) {
          console.log(error)
          vm.showError = true
          vm.message = 'Bir hata oluştu, lütfen daha sonra tekrar deneyiniz.'
        })
    },

    validateForm() {
      return true
    },

    tickTimer() {
      this.qrTimer--
      if (this.qrTimer > 0) {
        this.qrTimerTimeoutId = setTimeout(() => {
          this.qrTimerTimeoutId = null
          this.tickTimer()
        }, 1000)
      } else {
        this.qrTimerTimeoutId = null
        this.buildQRWebSocket()
      }
    }
  },

  created() {
    vm = this
  },

  mounted() {
    EventBus.$on('SetQrCode', this.setQrCode)
    this.buildQRWebSocket()
  },

  beforeDestroy() {
    EventBus.$off('SetQrCode', this.setQrCode)
    if (this.qrTimerTimeoutId !== null) {
      clearTimeout(this.qrTimerTimeoutId)
      this.qrTimerTimeoutId = null
    }
    this.closeQRWebSocket()
  }
}
</script>

<style lang="less" scoped>
@import '../style/common.less';

.logo {
  background-color: red;
  -webkit-mask: url(/back.svg) no-repeat center;
  mask: url(/back.svg) no-repeat center;
  width: 24px;
  height: 24px;
}

.appLogo {
  width: 100px;
}

.upperBand {
  background-color: var(--topBarColor);
  height: 100px;
  text-align: right;
}

.midBox {
  background-color: white;
  width: 90%;
  max-width: 600px;
  margin: auto;
  margin-top: -50px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  display: flex;
  flex-direction: column;
}

.organizationInfo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(245, 245, 245);

  & > img {
    max-height: 300px;
    width: 50%;
  }
}

.infoTitle {
  padding: 20px;
  font-size: 30px;
  text-align: center;
}

.infoContainer {
  padding: 25px;
  line-height: 24px;
  font-size: 14px;
  text-align: left;
}

.infoRow {
  display: flex;
}

.qrTimer {
  margin-top: -5px;
}

.flip-card {
  width: 100%;
  perspective: 1000px;
  height: ~'calc(100vh - 100vw)';
  min-height: 300px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.2s;
  transform-style: preserve-3d;
}

.flip-card.flipped .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
}

.flip-card-front {
  background-color: rgb(255, 255, 255);
  color: black;
  cursor: pointer;
}

.flip-card-back {
  background-color: white;
  transform: rotateY(180deg);
}

.svgContainer {
  color: var(--loginBtnColor);
}

.svgBackButton {
  fill: currentColor;
}

.credentialLogin {
  display: flex;
  justify-content: space-around;

  & > input {
    border: 1px solid rgb(228, 228, 228);
    background-color: rgb(243, 243, 243);
    padding: 10px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 16px;
    font-family: 'Raleway', sans-serif;
    outline: none;
  }

  & > input:focus {
    background-color: white;
  }
}

.inputTitle {
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  margin-left: 30px;
  margin-bottom: 5px;
  color: var(--colorTextColor);
}

.loginTitle {
  font-weight: 700;
  font-size: 20px;
  margin-top: 10px;
}

.loginRow {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
.loginBtn {
  background-color: var(--loginBtnColor);
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  max-width: 180px;
  display: flex;
  align-items: center;
  margin: 15px 20px 10px 0;
  align-self: flex-end;
  flex-shrink: 0;

  &:hover {
    background-color: var(--loginBtnHoverColor);
  }

  & > img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}

.errorMessage {
  background-color: rgb(228, 3, 3);
  color: white;
  padding: 10px;
  text-align: center;
  position: absolute;
  bottom: -10px;
  width: calc(100% - 20px);
  z-index: 999999;
}

@media (max-width: 768px) {
  .midBox {
    margin-top: 20px;
  }
}

@media (max-width: 540px) {
  .flip-card-back > * {
    margin-bottom: 1rem !important;
  }

  .credentialLogin {
    justify-content: flex-start;
    padding-top: 30px;
  }

  .infoContainer[data-v-26084dc2] {
    padding: 25px 5px;
    line-height: 22px;
    font-size: 13px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .infoRow {
    flex-direction: column;
  }

  .flip-card {
    height: calc(100vh - 38vw);
  }
}
</style>
